import styled from "styled-components";

export const BannerWarningContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  text-align: center;
  background-color: #1a1a1a;

  p {
    font: 600 1.875rem "inter";
    color: #f2f2f2 !important;
    margin: 0;
  }

  span {
    max-width: 500px;
    font: 400 1.125rem "inter";
    color: #c8c8c9;
    line-height: 27px;
  }
  @media screen and (max-width: 600px) {
    p {
      font-size: 1.5rem;
    }
    span {
      font-size: 1rem;
    }
  }
`;
